import { BlocoFormErrors, BlocoPayload } from "./types";

export function validateBloco(bloco: Partial<BlocoPayload>): BlocoFormErrors {
  const errors: BlocoFormErrors = {};

  if (!bloco.nome?.toString().trim()) errors.nome = "Nome é obrigatório";

  return errors;
}
